// extracted by mini-css-extract-plugin
export default {"generatedWords":"GeneratedWords_generatedWords__fR-I2","space":"GeneratedWords_space__NpwMK","spaceIcon":"GeneratedWords_spaceIcon__ZjgGS"};